import React, { useState, useContext } from "react";
import { createContext } from "react";

const UserNameContext = createContext();

export const useUserName = () => {
  return useContext(UserNameContext);
};

export const UserNameProvider = ({ children }) => {
  const [userName, setUserName] = useState("");

  const value = {
    userName,
    setUserName,
  };

  return (
    <UserNameContext.Provider value={value}>
      {children}
    </UserNameContext.Provider>
  );
};
